// openEHR AM model — public barrel (BMM packages in dependency order)
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

export * from "./aom2/mod.ts";
export * from "./_unassigned.ts";
